module.exports = __webpack_public_path__ + "img/amazon-pay.7eb3edab.png";